<template>
  <div>
    <Multiselect
      id="titles"
      v-model="selectedTitles"
      :options="titles"
      label="label"
      track-by="uuid"
      placeholder="Choose Title(s)"
      :multiple="true"
    />
  </div>
</template>

<script type="text/babel">
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'TitlesFieldComponent',
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapState({
      titles: state => state.union.membershipTitles,
    }),
    selectedTitles: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  async mounted() {
    await this.$nextTick()

    this.$store.dispatch('organizationGetMembershipTitles')
      .then(() => {
        this.loaded = true
      })
  },
}
</script>
